import { render, staticRenderFns } from "./ArchiveLink.vue?vue&type=template&id=61a73aad"
import script from "./ArchiveLink.vue?vue&type=script&lang=js"
export * from "./ArchiveLink.vue?vue&type=script&lang=js"
import style0 from "./ArchiveLink.vue?vue&type=style&index=0&id=61a73aad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports